export const agentPlayground = {
  header: {
    title: "Test dell'agente AI",
    chip: "Reception AI · Beta",
    sub: "Chatta con l'agente avanzato senza inviare nulla tramite WhatsApp.",
  },
  context: {
    title: "Contesto",
    listingLabel: "Annuncio",
    listingPlaceholder: "Seleziona un annuncio…",
    allListings: "🌐 Tutti gli alloggi (nuove prenotazioni)",
    accountModeHint:
      "L'agente risponde come se non fosse legato a un alloggio specifico: ideale per testare le richieste di prenotazione.",
    guestStatusLabel: "Stato dell'ospite",
    stay: {
      auto: "Automatico",
      inStay: "Attualmente in soggiorno (durante il soggiorno)",
      beforeArrival: "Non ancora arrivato (prenotazione futura)",
      after: "Soggiorno terminato",
    },
    guestStatusHint: "Simula il momento dell'ospite per vedere le diverse risposte.",
    reservationIdLabel: "ID prenotazione",
    optional: "(facoltativo)",
    reservationIdPlaceholder: "es. 1234",
    phoneLabel: "Telefono dell'ospite",
    phonePlaceholder: "+39...",
    langLabel: "Lingua",
    lang: {
      auto: "Automatico",
      es: "Spagnolo",
      en: "Inglese",
      pt: "Portoghese",
      fr: "Francese",
      de: "Tedesco",
      pl: "Polacco",
    },
    reset: "Reimposta conversazione",
  },
  debug: {
    resolvedTitle: "Contesto risolto",
    listing: "Annuncio",
    property: "Struttura",
    reservation: "Prenotazione",
    checkin: "Check-in",
    checkout: "Check-out",
    lang: "Lingua",
    toolsTitle: "Strumenti utilizzati",
  },
  chat: {
    emptyPrompt: "Scrivi un messaggio come se fossi l'ospite.",
    pay: "Paga",
    book: "Prenota",
    sentAsButton: "Su WhatsApp viene inviato come pulsante",
    sentAsList: "Su WhatsApp viene inviato come elenco · {button}",
    inputPlaceholder: "Scrivi un messaggio…",
  },
  suggestions: {
    s1: "A che ora è il check-in?",
    s2: "C'è il parcheggio?",
    s3: "C'è il wifi? Qual è la password?",
    s4: "Posso fare il check-in in anticipo?",
  },
  errors: {
    loadListings: "Impossibile caricare gli annunci.",
    chatError: "Errore durante la comunicazione con l'agente.",
    chatReplyFallback: "⚠️ Non sono riuscito a rispondere. Controlla il contesto o riprova.",
  },
  methods: {
    listingFallback: "Annuncio #{id}",
  },
};
